import * as defaultImport from "react-dom/server";
export * from "react-dom/server";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
